<template>
  <div>
    <!-- {{ activeStep }} -->
    <el-steps :active="activeStep" align-center finish-status="success">
      <!-- {{      :description="item.description" }} -->
      <!-- :class="{
          active: activeStep == arr3.length + arr1.length,
        }" -->
      <el-step
        v-for="(item, index) in stepList"
        :key="index"
        :title="item.title" />
    </el-steps>
  </div>
</template>

<script>
import { getMenu, queryExamPhase } from '@/api/menu';
import { parseTime } from '@/utils/ruoyi';

export default {
  name: 'StepsComponent',
  props: {
    steps: {
      type: Array,
      // default: () => [
      //   { title: '进行中', description: '考生报名' },
      //   { title: '待进行', description: '资格审核' },
      //   { title: '待进行', description: '考生缴费' },
      //   { title: '待进行', description: '打印准考证' },
      //   { title: '待进行', description: '成绩查询' },
      // ],
    },
  },
  data() {
    return {
      stepList: [],
      examId: null,
      phaseList: [],
      examList: [],
      internalActiveStep: null,
      arr1: [],
      arr2: [],
      arr3: [],
      activeStep: 0,
      phaseType: 0,
    };
  },
  watch: {
    steps: {
      handler(val) {
        if (val) {
          this.stepList = val;
          console.log(this.stepList, 'this.stepList======');
        } else {
          this.stepList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    },
    examId: {
      handler: function (val, oldVal) {
        if (val) {
          this.getExamPhase();
        }
      },
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.params, '2222------');
    if (this.$route.params.id) {
      this.examId = this.$route.params.id;
    }
    if (localStorage.getItem('examId')) {
      this.examId = JSON.parse(localStorage.getItem('examId'));
    }
    if (localStorage.getItem('phaseType')) {
      this.phaseType = JSON.parse(localStorage.getItem('phaseType'));
    }
  },
  computed: {},
  methods: {
    //查询当前考试阶段
    getExamPhase() {
      queryExamPhase({
        examId: this.examId,
      }).then((res) => {
        console.log(res, '547679------');
        if (res.code == 200 && res.data) {
          const currentDate = new Date();
          // 验证数据结构并提供默认值
          this.arr1 = Array.isArray(res.data['进行中'])
            ? res.data['进行中']
            : [];
          this.arr1.map((item) => {
            item.title = '进行中';
            return item;
          });
          this.arr2 = Array.isArray(res.data['未开始'])
            ? res.data['未开始']
            : [];
          this.arr2.map((item) => {
            item.title = '未开始';
            return item;
          });
          this.arr3 = Array.isArray(res.data['已结束'])
            ? res.data['已结束']
            : [];
          this.arr3.map((item) => {
            item.title = '已结束';
            return item;
          });
          //this.activeStep = this.arr3.length + this.arr1.length;

          this.examList = [...this.arr3, ...this.arr1, ...this.arr2];
          this.phaseList = this.examList.map((item) => {
            item.startTime = parseTime(item.startTime);
            item.endTime = parseTime(item.endTime);
            item.title = item.phaseName;
            return item;
          });
          // 按照 phaseType 升序排序
          this.phaseList.sort((a, b) => a.phaseType - b.phaseType);

          // 找到所有 title 为 '进行中' 的项
          const activeItems = this.phaseList.filter(
            (item) => item.title === '进行中'
          );

          // 找到 phaseType 最大的项
          if (activeItems.length > 0) {
            const maxPhaseTypeItem = activeItems.reduce(
              (maxItem, currentItem) => {
                return currentItem.phaseType > maxItem.phaseType
                  ? currentItem
                  : maxItem;
              }
            );
            this.internalActiveStep = maxPhaseTypeItem.phaseType;
          } else {
            this.internalActiveStep = 0; // 默认值
          }

          // phaseType 1 → sortValue 1
          // phaseType 2 → sortValue 2
          // phaseType 7 → sortValue 3
          // phaseType 8 → sortValue 4
          // phaseType 3 → sortValue 5
          // phaseType 4 → sortValue 6
          // phaseType 5 → sortValue 7
          // phaseType 6 → sortValue 8
          let targetArr = [];
          targetArr =
            this.phaseList.length > 0
              ? this.phaseList.map((item) => {
                  let sortValue;
                  switch (item.phaseType) {
                    case 1:
                      sortValue = 1;
                      break;
                    case 2:
                      sortValue = 2;
                      break;
                    case 7:
                      sortValue = 3;
                      break;
                    case 8:
                      sortValue = 4;
                      break;
                    case 3:
                      sortValue = 5;
                      break;
                    case 4:
                      sortValue = 6;
                      break;
                    case 5:
                      sortValue = 7;
                      break;
                    case 6:
                      sortValue = 8;
                      break;
                    default:
                      sortValue = null;
                  }
                  return { ...item, sort: sortValue };
                })
              : [];
          this.phaseList = targetArr;
          //按照sort升序排序
          this.phaseList.sort((a, b) => a.sort - b.sort);

          console.log(this.phaseList, 'phaseList=======');
          this.stepList = this.phaseList;
          let matchedItem = this.phaseList.findIndex(
            (item) => item.phaseType === this.phaseType
          );
          this.activeStep = matchedItem;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* 添加自定义样式 */
//当前正在进行中的步骤条样式改写
// .active {
//   ::v-deep .el-step__title.is-process {
//     color: $--color-primary;
//   }
//   ::v-deep .el-step__description.is-process {
//     color: $--color-primary;
//   }
//   ::v-deep .el-step__head.is-process {
//     .el-step__icon.is-text {
//       background-color: $--color-primary;
//       color: #fff;
//       border-color: $--color-primary;
//     }
//   }
// }
::v-deep .el-step__title.is-process {
  color: $--color-primary;
}
::v-deep .el-step__description.is-process {
  color: $--color-primary;
}
::v-deep .el-step__head.is-process {
  .el-step__icon.is-text {
    background-color: $--color-primary;
    color: #fff;
    border-color: $--color-primary;
  }
}
</style>
